module.exports = __webpack_public_path__ + "assets/green_check_mark-6caa00.svg";